import { gql } from '@urql/core';

export const TEAM_LIST_QUERY = gql`
  query TeamList {
    teams {
      nodes {
        id
        name
        description
        settings
      }
    }
  }
`;

export const TEAM_ONE_QUERY = gql`
  query TeamOne($id: String!) {
    team(id: $id) {
      id
      name
      description
      settings
    }
  }
`;

export const CREATE_TEAM_MUTATION = gql`
  mutation CreateTeam($input: CreateTeamInput!) {
    createTeam(input: $input) {
      id
      name
      description
      settings
    }
  }
`;

export const UPDATE_TEAM_MUTATION = gql`
  mutation UpdateTeam($id: String!, $input: UpdateTeamInput!) {
    updateTeam(id: $id, input: $input) {
      id
      name
      description
      settings
    }
  }
`;

export const DELETE_TEAM_MUTATION = gql`
  mutation DeleteTeam($id: String!) {
    deleteTeam(id: $id) {
      id
      name
      description
      settings
    }
  }
`;